import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from 'src/app/services/translate.service';

@Pipe({
  standalone: false, name: 'nullDisplay' })
export class NullDisplayPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {

  }

  transform(value: number | null | undefined | string): string {
    if (value === null || value === undefined || value === '') {
      return this.translateService.getDynamicTranslation('N/A');
    }
    return value.toString();
  }
}
